export default "__VITE_ASSET__C57GWcZf__"